import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "../../../ezUI/StyledComponents/utils";
import { AssetImageUrl } from "../../../assets/imgUrl";
import Constant, { setCookie, Host } from "../../../utils/constant";
import getLangKeyValueFun from "../../../utils/lang";
import langGroup from "../../../assets/lang.json";
const gettext = getLangKeyValueFun(langGroup);
const Container = styled.div `
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 3000;
	background: #ffffff;
	font-size: ${px2rem(16)};
	color: #333333;
	padding-top: ${px2rem(44)};
`;
const Header = styled.div `
	position: fixed;
	top: 0;
	width: 100%;
	height: ${px2rem(44)};
	padding: 0 ${px2rem(12)};
	border-bottom: 1px solid #e6e6e6;
	box-sizing: border-box;
	> div {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
const List = styled.div `
	height: 100%;
	overflow: scroll;
`;
const Close = styled.div `
	position: absolute;
	top: 50%;
	left: ${px2rem(12)};
	transform: translateY(-50%);
`;
const Title = styled.div `
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 800;
`;
const CurrencyItem = styled.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${px2rem(44)};
	margin-left: ${px2rem(12)};
	padding-right: ${px2rem(12)};
	border-bottom: 1px solid #e6e6e6;
	> img {
		display: none;
	}
	${(props) => props.checked &&
    css `
			color: #e33124;
			> img {
				display: block;
			}
		`};
`;
const ItemLeft = styled.div `
	display: flex;
	font-weight: 500;
	> em {
		width: ${px2rem(40)};
		font-style: normal;
	}
`;
const Type = {
    Currency: "Currency",
    Language: "Language"
};
class LangAndCur extends React.Component {
    constructor(props) {
        super(props);
        this.changeCurrency = item => {
            const BaseUrl = Host[String(Constant.isUat)];
            setCookie("ci-currency", item.currency_code, "/", BaseUrl.domain);
            window.location.reload();
        };
        this.changeLanguage = item => {
            const BaseUrl = Host[String(Constant.isUat)];
            setCookie("ci-language", item.language_code, "/", BaseUrl.domain);
            if (this.props.onChangeLanguage) {
                this.props.onChangeLanguage(item.language_code);
            }
            else {
                location.reload();
            }
        };
        this.state = {
            showSidebar: true
        };
    }
    componentDidMount() { }
    render() {
        const { list, title, stateChange } = this.props;
        return (React.createElement(Container, null,
            React.createElement(Header, null,
                React.createElement(Close, { onClick: () => stateChange(`show${title}Modal`, false) },
                    React.createElement("img", { src: AssetImageUrl["ic_back@3x.png"], width: 24 })),
                React.createElement(Title, null, gettext(title))),
            React.createElement(List, null,
                title === Type.Currency && (React.createElement("div", null, list.map((item, index) => {
                    return (React.createElement(CurrencyItem, { key: index, checked: item.currency_code === Constant.currency, onClick: () => this.changeCurrency(item) },
                        React.createElement(ItemLeft, null,
                            React.createElement("em", null, item.currency_symbol),
                            React.createElement("span", null, item.currency_code)),
                        React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 })));
                }))),
                title === Type.Language && (React.createElement("div", null, list.map((item, index) => {
                    return (React.createElement(CurrencyItem, { key: index, checked: item.language_code === Constant.language, onClick: () => this.changeLanguage(item) },
                        React.createElement(ItemLeft, null,
                            React.createElement("span", null, item.language_text)),
                        React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 })));
                }))))));
    }
}
export default LangAndCur;
